
import { ISubmittedContributionViewState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { LoadMoreAction, ResponseAction } from './actions';

export const loginState: ISubmittedContributionViewState = {
  list: [],
  currentPage: 0
};

const reducer = createReducer(loginState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      list: state.currentPage === 0 ? payload : state.list.concat(payload),
      currentPage: payload.length == 0 ? -1 : state.currentPage
    }

  }),
  on(LoadMoreAction, (state) => {
    return {
      ...state,
      currentPage: state.currentPage + 1
    };
  })
);

export function submittedContributionsViewReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
